import type { FunctionComponent } from 'react';
import React from 'react';

import { forTemplate } from '@trello/i18n';
const format = forTemplate('actions_empty');

interface ActionsEmptyProps {
  daysBack?: number;
}

export const ActionsEmpty: FunctionComponent<ActionsEmptyProps> = ({
  daysBack,
}) => (
  <p className="empty-list">
    {daysBack &&
      format('no-actions-in-the-last-daysback-days', {
        daysBack: daysBack,
      })}
    {!daysBack && format('no-actions')}
  </p>
);
